export const AUTOCOMPLETE = "cca.us.enable.autocomplete";
export const STJUDE_CHECKOUT_ROUND_UP_ENABLED =
  "87522937-a744-46b2-a306-efd943152a1d";
export const STJUDE_ENABLED = "CCA-stJude-Enabled";
